document.addEventListener('DOMContentLoaded', function() {
const btnREVIEW1 = document.getElementById('show-review1');
const btnREVIEW2 = document.getElementById('show-review2');
const btnREVIEW3 = document.getElementById('show-review3');
const btnREVIEW4 = document.getElementById('show-review4');
const btnREVIEW5 = document.getElementById('show-review5');
const btnREVIEW6 = document.getElementById('show-review6');
const btnREVIEW7 = document.getElementById('show-review7');
const btnREVIEW8 = document.getElementById('show-review8');
const btnREVIEW9 = document.getElementById('show-review9');
const btnREVIEW10 = document.getElementById('show-review10');
const btnREVIEW11 = document.getElementById('show-review11');
const btnREVIEW12 = document.getElementById('show-review12');
const btnREVIEW13 = document.getElementById('show-review13');
const btnREVIEW14 = document.getElementById('show-review14');
const btnREVIEW15 = document.getElementById('show-review15');
const btnREVIEW16 = document.getElementById('show-review16');
const btnREVIEW17 = document.getElementById('show-review17');
const btnREVIEW18 = document.getElementById('show-review18');
const btnREVIEW19 = document.getElementById('show-review19');
const btnREVIEW20 = document.getElementById('show-review20');
const btnREVIEW21 = document.getElementById('show-review21');
const btnREVIEW22 = document.getElementById('show-review22');
const btnREVIEW23 = document.getElementById('show-review23');
const btnREVIEW24 = document.getElementById('show-review24');
const btnREVIEW25 = document.getElementById('show-review25');
const btnREVIEW26 = document.getElementById('show-review26');
const btnREVIEW27 = document.getElementById('show-review27');
const btnREVIEW28 = document.getElementById('show-review28');
const btnREVIEW29 = document.getElementById('show-review29');
const btnREVIEW30 = document.getElementById('show-review30');
const btnREVIEW31 = document.getElementById('show-review31');
const btnREVIEW32 = document.getElementById('show-review32');

  

if (btnREVIEW1) {
    btnREVIEW1.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // ABCのコンテンツのみを表示
        document.querySelectorAll('.review1').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}

if (btnREVIEW2) {
    btnREVIEW2.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review2').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW3) {
    btnREVIEW3.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review3').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW4) {
    btnREVIEW4.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review4').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW5) {
    btnREVIEW5.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review5').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW6) {
    btnREVIEW6.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review6').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW7) {
    btnREVIEW7.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review7').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW8) {
    btnREVIEW8.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review8').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW9) {
    btnREVIEW9.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review9').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW10) {
    btnREVIEW10.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review10').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW11) {
    btnREVIEW11.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review11').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW12) {
    btnREVIEW12.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review12').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW13) {
    btnREVIEW13.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review13').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW14) {
    btnREVIEW14.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review14').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW15) {
    btnREVIEW15.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review15').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW16) {
    btnREVIEW16.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review16').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW17) {
    btnREVIEW17.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review17').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW18) {
    btnREVIEW18.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review18').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW19) {
    btnREVIEW19.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review19').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW20) {
    btnREVIEW20.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review20').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW21) {
    btnREVIEW21.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review21').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW22) {
    btnREVIEW22.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review22').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW23) {
    btnREVIEW23.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review23').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW24) {
    btnREVIEW24.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review24').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW25) {
    btnREVIEW25.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review25').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW26) {
    btnREVIEW26.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review26').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW27) {
    btnREVIEW27.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review27').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW28) {
    btnREVIEW28.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review28').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW29) {
    btnREVIEW29.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review29').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW30) {
    btnREVIEW30.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review30').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW31) {
    btnREVIEW31.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review31').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}


if (btnREVIEW32) {
    btnREVIEW32.addEventListener('click', function() {
        // すべてのコンテンツを非表示
        document.querySelectorAll('.content').forEach(function(el) {
            el.style.display = 'none';
        });
        
        // DEFのコンテンツのみを表示
        document.querySelectorAll('.review32').forEach(function(el) {
            el.style.display = 'block';
        });
    });
}
});